exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".custom-tree-node[data-v-79e2f91e]{-ms-flex:1;flex:1;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;font-size:15px;padding-right:8px;margin-top:10px;margin-bottom:10px}.el-row[data-v-79e2f91e]{margin-bottom:20px}.el-col[data-v-79e2f91e]{border-radius:4px}.bg-purple-dark[data-v-79e2f91e]{background:#99a9bf}.bg-purple[data-v-79e2f91e]{border:1px solid #f3f3f3;padding:10px;box-sizing:border-box}.grid-content[data-v-79e2f91e]{border-radius:4px;min-height:770px}.row-bg[data-v-79e2f91e]{padding:10px 0;background-color:#f9fafc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-79e2f91e","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/components/renewConfig.vue
// module id = 256
// module chunks = 0